import React, { useState, useEffect } from "react"
import axios from 'axios'
import TokenGrid from './TokenGrid'

export default function Main() {
  const [tokens, setTokens] = useState([])
  const [search, setSearch] = useState('')

  useEffect(() => {
    axios.get('https://api.coingecko.com/api/v3/coins/markets?vs_currency=aud&order=market_cap_desc&per_page=100&page=1&sparkline=false')
    .then(response => {
      setTokens(response.data)
    })
    .catch(error => alert('An error has occured loading your tokens'))
  }, [])

  const handleChange = (event) => {
    setSearch(event.target.value)
  }

  const filteredTokens = tokens.filter(token => token.name.toLowerCase().includes(search.toLowerCase()))

  return (
    <div className="App">
    <div className="token-search">
      <h1 className="token-title">Find your token</h1>
      <form>
        <input type="text" placeholder="search..." onChange={handleChange} className="token-input"></input>
      </form>
    </div>
  {filteredTokens.map(token => {
    return (
      <TokenGrid
      key={token.id} 
      token={token} 
      />
    )
  })}
  </div>
  )
}